<div [formGroup]="dateForm" class="row gx-2">
    <div *ngIf="isTransactionDateVisible" class="col-6">
        <mat-form-field appearance="fill">
            <mat-label>{{ transactionDateLabel }}</mat-label>
            <input
                matInput
                [matDatepicker]="transactionDatePicker"
                formControlName="transactionDate"
                [value]="transactionDate.value"
            />
            <mat-hint>{{ transactionDateHint }}</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="transactionDatePicker">
                <i-tabler matDatepickerToggleIcon name="calendar"></i-tabler>
            </mat-datepicker-toggle>
            <mat-datepicker #transactionDatePicker></mat-datepicker>
            <mat-error *ngIf="dateForm.controls.transactionDate as formControl">
                <ng-container *ngIf="formControl.hasError('required')">
                    Select a date
                </ng-container>
            </mat-error>
        </mat-form-field>
    </div>
    <div class="col-6">
        <mat-form-field appearance="fill">
            <mat-label>{{ settlementDateLabel }}</mat-label>
            <input
                matInput
                [matDatepicker]="settlementDatePicker"
                formControlName="settlementDate"
                [value]="settlementDate.value"
            />
            <mat-hint>{{ settlementDateHint }}</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="settlementDatePicker">
                <i-tabler matDatepickerToggleIcon name="calendar"></i-tabler>
            </mat-datepicker-toggle>
            <mat-datepicker #settlementDatePicker></mat-datepicker>
            <mat-error *ngIf="dateForm.controls.settlementDate as formControl">
                <ng-container *ngIf="formControl.hasError('required')">
                    Select a settlement date
                </ng-container>
                <!-- todo - add validation for ensuring settlement date is after transaction date-->
            </mat-error>
        </mat-form-field>
    </div>
</div>
